import React from 'react';
import classes from './UploadModal.module.scss';
import { availableIconFormat, documnentIcons } from 'helpers/documentIcons';
import Assets from 'assets/icons';
import { useTranslation } from 'react-i18next';
import { Collapse, ConfigProvider } from 'antd';
import { prepareStructure } from './structureHelper';
import { CollapsibleType } from 'antd/es/collapse/CollapsePanel';
import cn from 'classnames';

type ItemElementProps = {
  item: any;
  isConfidential: boolean;
  onDeleteItem: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, itemUids: string[]) => void;
  activeKeys?: any;
  setActiveKeys?: React.Dispatch<any>;
  activeKeysArr?: string[];
};

const ItemElement = ({item, isConfidential, onDeleteItem, activeKeys, setActiveKeys, activeKeysArr}: ItemElementProps) => {
  const { t } = useTranslation();
  const iconType = item.type === 'folder' ? 'folder' : item.name?.split('.').reverse()[0];
  const icon = availableIconFormat.includes(iconType!) ? iconType : 'default';

  const items = [{
    key: item.path?.split('/')[0],
    showArrow: Boolean(item.type === 'folder'),
    collapsible: Boolean(item.type === 'folder') ? 'header' : 'icon' as CollapsibleType,
    label: <div className={classes.oneItem}>
      <div className={cn(classes.oneItemDiv, Boolean(item.type === 'folder') ? classes.addBtn : 'null')}>

        <div className={classes.oneItemIcon}>
          {documnentIcons[icon as keyof typeof documnentIcons]}
  
          {isConfidential && <div className={classes.shield}>
            <Assets.ShieldIcon  />
          </div>}
        </div>
  
        <div className={classes.oneItemText}>
          <div>{item.name}</div>
            {iconType === 'folder' && <div className={classes.countElement}>
              {t('Documents.modals.upload.countElement')}{item.children.length}
            </div>}
          </div>
        </div>
        <div
          className={classes.oneItemDelete}
          onClick={(e) => onDeleteItem(e, item.children?.map((child: any) => child.uid))}
        >
          {' '}
          <Assets.TrashIcon />{' '}
        </div>
    </div>,
    children: item.type === 'folder'
      ? prepareStructure(item.children).map((elem: any, i: number) => {
          return (<ItemElement
            key={elem.name + i}
            item={elem}
            isConfidential={isConfidential}
            onDeleteItem={onDeleteItem}
            activeKeys={activeKeys}
            setActiveKeys={setActiveKeys}
            activeKeysArr={activeKeysArr}
          />)
        }
      )
      : null,
  }];

  // const onChange = (keys: string[]) => {
  //   setActiveKeys((prev: any) => {      
  //     return {...prev, [item.path?.split('/')[0]]: keys}
  //   });    
  // };

  return (
    <ConfigProvider theme={{
      components: { Collapse: {
        contentPadding: 8,
        headerPadding: 8,
      }},
    }}>
      <Collapse
        items={items}
        // onChange={onChange}
        // activeKey={activeKeysArr}
      />
    </ConfigProvider>
  );
}

export default ItemElement;
